import { render, staticRenderFns } from "./period-form.vue?vue&type=template&id=365c1d6c&scoped=true"
import script from "./period-form.vue?vue&type=script&lang=ts"
export * from "./period-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c1d6c",
  null
  
)

export default component.exports